import React from "react";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useMemo } from "react";
import { getAccessTokenDataPools } from "redux/actions";
import { Tooltip } from "antd";
const routeIdSelector = (state) => state.playlist.data.routeID;
const sessionsSelector = (state) => state.sessions;
const dataPoolsSelector = (state) => state.dataPools;

const streamOffsetsSelector = (state) => state.playlist.data.offsets;

const SessionInfoTab = () => {
    const dispatch = useDispatch();
    const sessions = useSelector(sessionsSelector);
    const routeID = useSelector(routeIdSelector);
    const streamOffsets = useSelector(streamOffsetsSelector);
    const dataPools = useSelector(dataPoolsSelector);

    useEffect(() => {
        if (_.isEmpty(dataPools)) {
            dispatch(getAccessTokenDataPools());
        }
    }, [dispatch, dataPools]);

    const sessionStreamInfo = useMemo(() => {
        return _.get(sessions, [routeID, "stream_info"], []);
    }, [sessions, routeID]);

    const sessionDataPoolID = useMemo(() => {
        return _.get(sessions, [routeID, "data_pool"], null);
    }, [routeID, sessions]);

    const sessionDataPool = useMemo(() => {
        const dpIndex = _.findIndex(dataPools, { id: sessionDataPoolID });
        const dataPoolName = _.get(dataPools, [dpIndex, "name"], "Unknown");
        return dataPoolName;
    }, [dataPools, sessionDataPoolID]);

    const combinedStreamInfo = useMemo(() => {
        let newList = [];
        _.forEach(sessionStreamInfo, (stream, idx) => {
            const newStream = {
                ...stream,
                offset: _.get(streamOffsets, idx),
            };
            newList.push(newStream);
        });

        return newList;
    }, [sessionStreamInfo, streamOffsets]);

    return (
        <div className="SessionInfoTabMain">
            <div>
                <strong>Session's Data Pool:</strong> {sessionDataPool} (ID: {sessionDataPoolID})
            </div>
            <div className="SessionInfoTabMainTitle">Available Session Streams:</div>
            <div className="SessionInfoTabMainStreamsList">
                {_.map(combinedStreamInfo, (streamInfo, idx) => {
                    return (
                        <div
                            className="SessionInfoTabStreamInfoMain"
                            key={idx}>
                            <div className="SessionInfoTabStreamInfoMainTopRow">
                                <div className="SessionInfoTabStreamInfoMainItem">
                                    <div className="SessionInfoTabStreamInfoMainItemValue">
                                        <span style={{ fontWeight: "bold" }}>{_.get(streamInfo, "type", "unknown")}</span> (
                                        {_.get(streamInfo, "label", "unknown")})
                                    </div>
                                </div>
                                <div className="SessionInfoTabStreamInfoMainRightSide">
                                    <div>
                                        Stream Index: <strong>{_.get(streamInfo, "stream_index", "unknown")}</strong>
                                    </div>
                                    <Tooltip
                                        title={_.get(streamInfo, "archived", false) ? "Stream has been archived" : "Stream is visible (NOT archived)"}
                                        placement="topLeft">
                                        <div className={`SessionInfoTabStreamInfoMainStatus ${_.get(streamInfo, "archived", false) ? "Archived" : ""}`}>
                                            {_.get(streamInfo, "archived", false) ? "Archived" : "Visible"}
                                        </div>
                                    </Tooltip>
                                </div>
                            </div>
                            <div className="SessionInfoTabStreamInfoMainItem">
                                <div className="SessionInfoTabStreamInfoMainItemLabel">Offset:</div>
                                <div className="SessionInfoTabStreamInfoMainItemValue">{_.get(streamInfo, "offset", "unknown")}m</div>
                            </div>
                            <div className="SessionInfoTabStreamInfoMainItem">
                                <div className="SessionInfoTabStreamInfoMainItemLabel">Source Index:</div>
                                <div className="SessionInfoTabStreamInfoMainItemValue">{_.get(streamInfo, "source", "unknown")}</div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SessionInfoTab;
